<template>
  <div class="menu">
    <ul class="items type-h1">
      <li
        v-for="item in nav.menu"
        class="item"
        :key="item._uid"
      >
        <Cta :blok="item">
          <HoverReveal>{{ item.label }}</HoverReveal>
        </Cta>
      </li>
    </ul>
    <div class="bottom">
      <!-- <div class="address mobile-only">{{ nav.address }}</div> -->
      <ul class="socials">
        <li
          v-for="item in nav.socials"
          :key="item._uid"
        >
          <Cta :blok="item">
            <HoverReveal>{{ item.label }}</HoverReveal>
          </Cta>
        </li>
      </ul>
    </div>

    <div class="bottom">
      <ul class="socials">
        <li
          v-for="item in nav.misc"
          :key="item._uid"
        >
          <Cta :blok="item">
            <HoverReveal>{{ item.label }}</HoverReveal>
          </Cta>
        </li>
      </ul>
    </div>

    <!-- <Cta
      :blok="nav.contact_to"
      class="contact mobile-only"
    >
      <div class="copy">
        <div class="heading">{{ nav.contact_heading }}</div>
        <div class="desc">{{ nav.contact_desc }}</div>
      </div>
      <IconArrowForward class="icon" />
    </Cta> -->
  </div>
</template>

<script setup lang="ts">
import IconArrowForward from "@/icons/arrow-forward-20.svg?component"

const props = defineProps({})

const emits = defineEmits([])

const { $gsap, $ScrollTrigger } = useNuxtApp()

const { app, debug, browser } = useStores()

const refRoot = ref(null)

const config = useRuntimeConfig()
let opts = {}
if (config.public.SB_VERSION == "draft") {
  opts.version = "draft"
}
const navStory = await useStory("/global/the-nav", opts)
const nav = computed(() => navStory.value?.content)
console.log("TheMenu.nav", JSON.parse(JSON.stringify(nav.value)))

const route = useRoute()
watch(
  () => route.path,
  () => {
    app.setModalId(null)
  }
)
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";

.menu {
  min-height: calc(100lvh - 4.8rem * 2);
  max-height: 100%;
  @include flex(column, flex-end, flex-start);
  background: rgba($cl-gray-purple, 0.8);

  padding: 4rem;
  padding-top: calc(var(--nav-height) - 3rem);
}

.items {
  flex: 1;
  @include flex(column, center, flex-start);
}

// .item {
//   margin-top: $p0;

//   &:last-child {
//     margin-bottom: 0;
//   }
// }

.bottom {
  color: rgba($cl-light, 0.6);
  width: 100%;
}

.bottom {
  color: rgba($cl-light, 0.6);
  border-top: 1px solid rgba($cl-light, 0.15);
  margin-top: 3.6rem;
  padding-top: 1.6rem;

  &:last-child {
    margin-top: 1.6rem;
  }
}

.contact {
  display: block;
  width: 100%;
  border: 1px solid rgba($cl-light, 0.15);
  padding: 2rem 3rem;
  margin-top: $p5;
  border-radius: 1rem;
  @include flex(row, space-between, center);

  .heading {
    color: rgba($cl-light, 0.8);
  }
  .desc {
    color: rgba($cl-light, 0.3);
  }

  .icon {
    color: $cl-light;
    width: 2rem;
  }
}

.cta {
  :deep(.reveal-content) {
    @include gradientText();
  }
}

@include mobile {
  .menu {
    padding: 2rem;
    padding-top: var(--nav-height);
    min-height: 100lvh;
  }

  .item {
    margin-top: $p1;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .bottom {
    @include flex(row, flex-start, flex-start);
    border-top: none;

    .address {
      width: 50%;
      margin-right: 2rem;
    }
  }
}
</style>
